import React, { useState, useEffect } from "react";

export const SingleLibraryDoc = ({ title, docType, file, url }) => {
  const [svgType, setSvgType] = useState("pdf");
  const [svgBgColor, setSvgBgColor] = useState("");
  // Build open URL to avoid forced downloads for Office docs
  const buildOpenHref = (rawUrl) => {
    if (!rawUrl) return "#";
    const type = (docType || "").toLowerCase();
    const officeTypes = ["doc", "docx", "ppt", "pptx", "xls", "xlsx"];
    if (officeTypes.includes(type)) {
      // Use Office Online Viewer for Office files
      return `https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(
        rawUrl
      )}`;
    }
    if (type === "pdf") {
      // Use Google Docs Viewer for PDFs to avoid forced downloads
      return `https://docs.google.com/gview?embedded=1&url=${encodeURIComponent(
        rawUrl
      )}`;
    }
    return rawUrl;
  };
  useEffect(() => {
    switch (docType) {
      case "pdf":
        setSvgType("pdf");
        break;
      case "doc":
        setSvgType("document");
        break;
      case "docx":
        setSvgType("document");
        break;
      case "pptx":
        setSvgType("powerpoint");
        break;
      case "xls":
        setSvgType("keynote");
        break;
      default:
        setSvgType("pdf");
    }
    //eslint-disable-next-line
  }, []);
  useEffect(() => {
    switch (docType) {
      case "pdf":
        setSvgBgColor("bg-background-blue");
        break;
      case "doc":
        setSvgBgColor("bg-background-purple");
        break;
      case "docx":
        setSvgBgColor("bg-background-purple");
        break;
      case "pptx":
        setSvgBgColor("bg-background-red");
        break;
      case "xls":
        setSvgBgColor("bg-background-teal");
        break;
      default:
        setSvgBgColor("bg-background-blue");
    }
    //eslint-disable-next-line
  }, []);
  return (
    <div className="flex flex-col items-center ">
      {file && !url && (
        <a
          href={buildOpenHref(file?.url)}
          target="_blank"
          rel="noopener noreferrer"
          className="space-y-6 focus:outline-none"
        >
          <p className={`w-16 h-16 mx-auto link-icon-wrapper ${svgBgColor}`}>
            <svg role="img" className="w-10 link-icon text-primary-black">
              <use xlinkHref={`/assets/img/necromancers.svg#${svgType}`} />
            </svg>
          </p>
          <p tabIndex="0" className="w-48 text-center">
            {title}
          </p>
        </a>
      )}
      {file && url && (
        <a
          href={buildOpenHref(url)}
          target="_blank"
          rel="noopener noreferrer"
          className="space-y-6 focus:outline-none"
        >
          <p className={`w-16 h-16 mx-auto link-icon-wrapper ${svgBgColor}`}>
            <svg role="img" className="w-10 link-icon text-primary-black">
              <use xlinkHref={`/assets/img/necromancers.svg#${svgType}`} />
            </svg>
          </p>
          <p tabIndex="0" className="w-48 text-center">
            {title}
          </p>
        </a>
      )}
      {!file && url && (
        <a
          href={buildOpenHref(url)}
          target="_blank"
          rel="noopener noreferrer"
          className="space-y-6 focus:outline-none"
        >
          <p className={`w-16 h-16 mx-auto link-icon-wrapper ${svgBgColor}`}>
            <svg role="img" className="w-10 link-icon text-primary-black">
              <use xlinkHref={`/assets/img/necromancers.svg#${svgType}`} />
            </svg>
          </p>
          <p tabIndex="0" className="w-48 text-center">
            {title}
          </p>
        </a>
      )}
    </div>
  );
};
